import moment from 'moment';
import {
  CPF as CPF_IDENTITY_TYPE,
  RG as RG_IDENTITY_TYPE,
} from '@/data/identity-types';

function blankForm() {
  return {
    id: null,
    scheduleId: null,
    schedule: { id: null, notes: '' },
    type: null,
    startDate: '',
    endDate: '',
    patient: {
      canSave: false,
      isIdentitySaved: false,
      image: {
        file: null,
        preview: null,
        showOptions: false,
        showWebCam: false,
      },
      id: null,
      name: '',
      socialName: '',
      birthDate: '',
      gender: '',
      identity: {
        type: CPF_IDENTITY_TYPE,
        value: '',
      },
      secondaryIdentity: {
        type: RG_IDENTITY_TYPE,
        value: '',
      },
      civilStatus: '',
      profession: {
        code: '',
        name: '',
      },
      phone: '',
      cellphone: '',
      email: '',
      insurance: {
        id: '',
        name: '',
        record: '',
        validity: '',
        plan: {
          id: '',
          name: '',
        },
      },
      address: {
        id: '',
        type: '',
        postalCode: '',
        addressLine1: '',
        addressLine2: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      imageUrl: '',
      alert: '',
      notes: '',
      cns: '',
      motherName: '',
      fatherName: '',
    },
    insurance: {
      id: '',
      name: '',
      record: '',
      validity: '',
      type: '',
      plan: {
        id: '',
        name: '',
        settings: {
          tiss: {
            enabled: false,
            consultationInSadt: false,
          },
          aso: {
            requiredClient: false,
          },
          record: {
            required: false,
            requiredValidity: false,
            digits: {
              enabled: false,
              min: 0,
              max: 0,
            },
          },
        },
      },
    },
    professional: {
      id: '',
      name: '',
      council: {
        record: '',
        name: '',
        state: '',
      },
      specialty: '',
    },
    expenses: [],
    status: 'scheduled',
    notes: '',
    arrivedAt: null,
    key: null,
    slot: false,
    reserves: 1,
    meta: null,
    bundleId: null,
    bundle: {
      current: '',
      total: '',
    },
    service: {
      startedAt: '',
      finishedAt: '',
    },
    asoClient: {
      id: '',
      name: '',
    },
    markerId: null,
    placeId: null,
    indicated: {
      id: '',
      entityId: '',
      name: '',
      type: 'professional',
      council: {
        name: 'CRM',
        state: 'PR',
        record: '',
      },
      specialty: {
        code: '',
        name: '',
      },
    },
    inUseBy: null,
  };
}

function blankFilter() {
  return {
    date: moment().format('YYYY-MM-DD'),
    viewMode: 'day',
    expenses: [],
    expenseId: '',
    insurances: [],
    insuranceId: '',
    schedules: [],
    scheduleId: '',
    professionalId: '',
    search: '',
    type: '',
  };
}

export default {
  show: false,
  accountShow: false,
  searchShow: false,
  printShow: false,
  commitmentShow: false,
  slotShow: false,
  slotWeekDaySelectorShow: false,
  weekDaySelectorShow: false,
  schedules: [],
  professionals: [],
  insurances: [],
  items: [],
  loading: false,
  showFiles: false,
  showHistory: false,
  waitingListCount: 0,
  blankForm,
  form: blankForm(),
  currentMonth: null,
  available: {
    days: [],
    professionals: [],
    insurancePlans: [],
  },
  blankFilter,
  filter: blankFilter(),
  clipboard: {
    event: null,
    data: null,
  },
  api: {
    professional: {
      status: 'pending',
      items: [],
    },
  },
};
